import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import Edit from './Edit';
import { Footer, Partners, PlantsList, PostDetails } from './components/index';
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import { IdElementProvider } from './context/IdElementContext';
import { Auth0Provider } from "@auth0/auth0-react";
import reportWebVitals from './reportWebVitals';

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))
// const editRoute = `${window.location.origin}/edit`;
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
// const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI;

ReactDOM.render(
  // >
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={`${window.location.origin}/edit`}
  >
  <Provider store={store}>
    <React.StrictMode>
      <IdElementProvider>
        <Router>
          <Switch>
            <Route exact path='/' component={App} />
            <Route path='/edit' component={Edit}/>
            <Route path='/partners' component={Partners}/>
            <Route path='/plants' component={PlantsList}/>
            <Route path='/detail/:categorie/:id' component={PostDetails}/>
          </Switch>
          <Footer />
        </Router>
      </IdElementProvider>
    </React.StrictMode>
  </Provider>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
